import { ChangeDetectorRef, Component, inject, Inject, Input, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { RestClient } from "../../../Api/DcoApi/Client/RestClient";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { Splash } from "../../../Akte/Controlls/Splash";
import { Leitstelle } from "../../../Api/DcoApi/Admin/AdminClasses2";
import { ToastService } from "../../../Akte/Services/Toasts/ToastService";
import { AddressEdit } from "../../../Akte/Controlls/AddressEdit";
import { AdminCard } from "../Sonstige/AdminCard";


@Component({
  imports: [
    CommonModule,
    Splash,
    AddressEdit,
    FormsModule, AdminCard
  ],
  selector: 'LeitsetlleEdit',
  templateUrl: './LeitsetlleEdit.html',
  standalone: true,
  styleUrl: './LeitsetlleEdit.css'
})
export class LeitsetlleEdit implements OnInit {
  toastService: ToastService; 
  ngOnInit(): void {
    this.GetData();
  }
  constructor(private cdr: ChangeDetectorRef) {
    this.toastService = inject(ToastService)
  }
  @Input() Key?: string | null = null;

  Client: RestClient = new RestClient();

  Entry: Leitstelle | null = null;

  async GetData() {
    if (!this.Key || this.Key == null || this.Key == "0" || isNaN(Number(this.Key)))
      this.Entry = { key: 0 } as Leitstelle;
    else
      this.Entry = await this.Client.Get<Leitstelle>(`/Backend/Api/V2/Admin/Leitstelle/${this.Key}`);
    this.cdr.detectChanges();
  }

  async SaveData() {
    if (this.Entry && this.Entry !== null) {
      if (this.Entry.key == 0)
        this.Entry =  await this.Client.Post<Leitstelle, Leitstelle>("/Backend/Api/V2/Admin/Leitstelle", this.Entry);
      else
        this.Entry =  await this.Client.Put<Leitstelle, Leitstelle>(`/Backend/Api/V2/Admin/Leitstelle`, this.Entry);

      this.toastService.show({ template: this.successTpl, classname: 'bg-success text-light show', delay: 10000 })
    }
  }

  @ViewChild('successTpl') public successTpl!: TemplateRef<any>;
}
